var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "box-wrapper" }, [
    _c(
      "ul",
      { staticClass: "pagination" },
      [
        _c("li", { staticClass: "pagination-item" }, [
          _c(
            "button",
            {
              staticClass: "side-navigation",
              attrs: {
                type: "button",
                disabled: _vm.isInFirstPage,
                "aria-label": "Go to previous page",
              },
              on: { click: _vm.onClickPreviousPage },
            },
            [
              _c("img", {
                staticClass: "left-transform",
                attrs: {
                  src: "/static/images/icons/chevron_right.svg",
                  alt: "chevron-right-icon",
                },
              }),
            ]
          ),
        ]),
        _c("li", { staticClass: "pagination-item" }, [
          _vm.totalPages > _vm.maxVisibleButtons && _vm.currentPage > 2
            ? _c(
                "button",
                {
                  attrs: {
                    type: "button",
                    "aria-label": `Go to page number ${1}`,
                  },
                  on: {
                    click: function ($event) {
                      return _vm.onClickPage(1)
                    },
                  },
                },
                [_vm._v("1")]
              )
            : _vm._e(),
        ]),
        _vm.totalPages > _vm.maxVisibleButtons + 1 && _vm.currentPage > 3
          ? _c("li", [
              _c("img", {
                staticClass: "pagination_dots",
                attrs: {
                  src: "/static/images/icons/pagination_dots.svg",
                  alt: "pagination-dots-icon",
                },
              }),
            ])
          : _vm._e(),
        _vm._l(_vm.pages, function (page, index) {
          return _c(
            "li",
            {
              key: index,
              staticClass: "pagination-item",
              class: { active: _vm.isPageActive(page.name) },
            },
            [
              _c(
                "button",
                {
                  attrs: {
                    type: "button",
                    disabled: page.isDisabled,
                    "aria-label": `Go to page number ${page.name}`,
                  },
                  on: {
                    click: function ($event) {
                      return _vm.onClickPage(page.name)
                    },
                  },
                },
                [_vm._v(_vm._s(page.name))]
              ),
            ]
          )
        }),
        _vm.dotsVisible
          ? _c("li", [
              _c("img", {
                staticClass: "pagination_dots",
                attrs: {
                  src: "/static/images/icons/pagination_dots.svg",
                  alt: "pagination-dots-icon",
                },
              }),
            ])
          : _vm._e(),
        _vm.validateLastPage
          ? _c(
              "li",
              {
                staticClass: "pagination-item",
                class: { active: _vm.isPageActive(_vm.totalPages) },
              },
              [
                _c(
                  "button",
                  {
                    attrs: {
                      type: "button",
                      "aria-label": `Go to page number ${_vm.totalPages}`,
                    },
                    on: {
                      click: function ($event) {
                        return _vm.onClickPage(_vm.totalPages)
                      },
                    },
                  },
                  [_vm._v(_vm._s(_vm.totalPages))]
                ),
              ]
            )
          : _vm._e(),
        _c("li", { staticClass: "pagination-item" }, [
          _c(
            "button",
            {
              staticClass: "side-navigation",
              attrs: {
                type: "button",
                disabled: _vm.isInLastPage,
                "aria-label": "Go to next page",
              },
              on: { click: _vm.onClickNextPage },
            },
            [
              _c("img", {
                attrs: {
                  src: "/static/images/icons/chevron_right.svg",
                  alt: "chevron-right-icon",
                },
              }),
            ]
          ),
        ]),
      ],
      2
    ),
    _c("div", { staticClass: "dis-inline fs-16 fw-normal" }, [
      _c("span", [_vm._v(_vm._s(_vm.currentRecords))]),
      _c("span", [_vm._v("of")]),
      _c("span", [_vm._v(_vm._s(_vm.total))]),
      _c("span", [_vm._v("Records")]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }